import { useState } from "react";

export default function PermissionModal({ show, onClose, onSave }) {
  const [permission, setPermission] = useState({
    label: "",
    permission: "",
    description: "",
  });
  const [isAdmin, setIsAdmin] = useState(false);

  const handleChange = (field, value) => {
    setPermission((prev) => ({ ...prev, [field]: value }));
  };

  const handleAdminToggle = () => {
    if (!isAdmin) {
      setPermission({
        label: "Administrador Total (*)",
        permission: "*",
        description: "Permissão total do sistema - acesso completo a todos os recursos",
      });
      setIsAdmin(true);
    } else {
      setPermission({
        label: "",
        permission: "",
        description: "",
      });
      setIsAdmin(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!permission.label || !permission.permission) {
      alert("Por favor, preencha o label e o identificador da permissão");
      return;
    }

    onSave(permission);

    // Reset form
    setPermission({
      label: "",
      permission: "",
      description: "",
    });
    setIsAdmin(false);
  };

  const handleClose = () => {
    // Reset form
    setPermission({
      label: "",
      permission: "",
      description: "",
    });
    setIsAdmin(false);
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Nova Permissão</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="adminPermission"
                  checked={isAdmin}
                  onChange={handleAdminToggle}
                />
                <label className="form-check-label" htmlFor="adminPermission">
                  <strong>Permissão de Administrador Total (*)</strong>
                  <small className="d-block text-muted">
                    Esta permissão especial dá acesso completo ao sistema
                  </small>
                </label>
              </div>

              <hr />

              <div className="mb-3">
                <label className="form-label">
                  Label <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={permission.label}
                  onChange={(e) => handleChange("label", e.target.value)}
                  placeholder="Ex: users.create"
                  required
                  disabled={isAdmin}
                />
                <small className="text-muted">
                  Identificador legível da permissão (ex: users.create, reports.view)
                </small>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Identificador <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={permission.permission}
                  onChange={(e) => handleChange("permission", e.target.value)}
                  placeholder="Ex: CREATE_USER"
                  required
                  disabled={isAdmin}
                />
                <small className="text-muted">
                  Identificador técnico usado no código (ex: CREATE_USER, VIEW_REPORTS)
                </small>
              </div>

              <div className="mb-3">
                <label className="form-label">Descrição</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={permission.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Descrição opcional da permissão..."
                  disabled={isAdmin}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary">
                Criar Permissão
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}